<div class="dasboard-width">
    <div class="row header mar-lft-rgt-0">
        <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
      <div class="col-md-3">View Template and Report</div>
      <!-- <div class="col-md-3">
        <ol class="breadcrumb cust-bread">
          <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting()"><i
                  class="fa fa-dashboard"></i> Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">View Template and Report</li>
        </ol>
      </div> -->
  
    </div>
    <div class="row content mr-top-5 mar-lft-rgt-0">
      <div class="col-md-6">
          <div class="form-group">
              <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="templateSelected"
                      (change)="onTemplateChange($event.target.selectedIndex)">
                <option *ngFor="let template of templateArray" [value]="template.id">{{template.template_name}}</option>
              </select>
          </div>
      </div>
    </div>
    <div class="row content mr-top-5 mar-lft-rgt-0">
      <div  class="col-md-12">
        <div *ngIf="tableView">
            <angular-slickgrid gridId='common-grid'
                (onAngularGridCreated)="angularGridReady($event)"
                [columnDefinitions]="columnDefinitions"
                [gridOptions]="gridOptions"
                [dataset]="reportTableObj"
            >
            </angular-slickgrid>
        </div>
        <div *ngIf="graphView">
            graphView
        </div>
      </div>
    </div>
  
  </div>
  
  